import {
    Button,
    FormControl,
    FormControlLabel,
    FormLabel,
    Modal,
    Radio,
    RadioGroup,
    TextField,
    Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useState } from "react";

const StyledArchiveRecordContainer = styled("div")({
    display: "flex",
    flexDirection: "column",
    background: "white",
    top: "50%",
    left: "50%",
    width: "400px",
    height: "250px",
    transform: "translate(-50%, -50%)",
    position: "absolute",
    alignItems: "center",
    borderRadius: "3px",
    boxShadow: "0 3px 7px rgba(0, 0, 0, 0.3)",
});

const StyledModalHeader = styled(Typography)({
    alignSelf: "center",
    marginTop: "5%",
});

const StyledFormContainer = styled("div")({
    display: "flex",
    justifyContent: "space-around",
    flexDirection: "column",
    width: "80%",
    height: "90%",
});

const StyledRadioGroup = styled(RadioGroup)({
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignItems: "center",
    justifyContent: "center",
});

const StyledFormControl = styled(FormControl)({
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignItems: "center",
    justifyContent: "center",
});

const StyledDateTextFieldContainer = styled("form")({
    display: "flex",
    alignItems: "baseline",
});

const StyledDateTextField = styled(TextField)({
    width: "100%",
    "& .MuiInputBase-input": {
        padding: "1vh 0.5vw",
        border: "none",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgba(0, 0, 0, 0.23)",
    },
    "& .MuiInputBase-root": {
        border: "none",
    },
});

const StyledSubmitButtonsContainer = styled("div")({
    display: "flex",
    flexDirection: "row",
    alignSelf: "end",
});

const AssetServicesSnapshotModal = (props) => {
    const currentDate = new Date();
    const formatDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;

    const {
        archiveAssetServicesRecord,
        clearErrorByField,
        errors,
        open,
        propertyKey,
        propertyManagementKey,
        toggleModal,
    } = props;

    const [managementRetained, toggleManagementRetained] = useState("true");
    const [terminationDate, selectTerminationDate] = useState(formatDate);

    const toggleModalClose = () => {
        clearErrorByField("archiveAssetServices");
        toggleModal(false);
    };

    const toggleRadio = (value) => {
        toggleManagementRetained(value);
    };

    const handleSubmit = async (propertyManagementKey, propertyKey, managementRetained, errors) => {
        const boolManagementRetained = managementRetained === "true" ? true : false;
        const record = {
            managementRetained: boolManagementRetained,
            terminationDate,
        };
        const result = await archiveAssetServicesRecord(propertyManagementKey, record, propertyKey, errors);
        if (result.success) {
            toggleModalClose();
        }
    };

    return (
        <Modal
            aria-labelledby="asset-services-snapshot-modal"
            aria-describedby="saves a new archive snapshot of the current property management information"
            open={open}
            onClose={toggleModalClose}
        >
            <StyledArchiveRecordContainer>
                <StyledModalHeader variant="h5">Archive Asset Record?</StyledModalHeader>
                <StyledFormContainer>
                    <RetainManagementRadioGroup toggleRadio={toggleRadio} managementRetained={managementRetained} />
                    <DateTextField selectTerminationDate={selectTerminationDate} errors={errors} />
                    <FormSubmitButtons
                        toggleModalClose={toggleModalClose}
                        handleSubmit={() =>
                            handleSubmit(propertyManagementKey, propertyKey, managementRetained, errors)
                        }
                    />
                </StyledFormContainer>
            </StyledArchiveRecordContainer>
        </Modal>
    );
};

const RetainManagementRadioGroup = (props) => {
    const { toggleRadio, managementRetained } = props;
    return (
        <StyledFormControl>
            <FormLabel id="retain-management">Retain management:</FormLabel>
            <StyledRadioGroup
                aria-labelledby="retain-management"
                defaultValue={"true"}
                name="radio-buttons-group"
                value={managementRetained}
                onChange={(e) => {
                    toggleRadio(e.target.value);
                }}
            >
                <FormControlLabel value={"true"} control={<Radio color="primary" />} label="Yes" />
                <FormControlLabel value={"false"} control={<Radio color="primary" />} label="No" />
            </StyledRadioGroup>
        </StyledFormControl>
    );
};

const DateTextField = (props) => {
    const { errors, selectTerminationDate } = props;
    const today = new Date().toISOString().slice(0, 10);
    return (
        <StyledDateTextFieldContainer>
            <FormLabel>Archive Date:</FormLabel>
            <StyledDateTextField
                id="date"
                type="date"
                defaultValue={today}
                slotProps={{
                    input: {
                        inputProps: { max: today },
                    },
                }}
                onChange={(e) => {
                    selectTerminationDate(e.target.value);
                }}
                helperText="Required"
                error={errors.archiveAssetServices?.terminationDate}
            />
        </StyledDateTextFieldContainer>
    );
};

const FormSubmitButtons = (props) => {
    const { toggleModalClose, handleSubmit } = props;
    return (
        <React.Fragment>
            <StyledSubmitButtonsContainer>
                <Button variant="outlined" color="primary" onClick={toggleModalClose}>
                    No
                </Button>
                <Button variant="contained" color="primary" onClick={handleSubmit}>
                    Yes
                </Button>
            </StyledSubmitButtonsContainer>
        </React.Fragment>
    );
};

export default AssetServicesSnapshotModal;
